module.exports = __webpack_public_path__ + "mester.jpg?cfb014b391eeabdcfb277c77328c6a97";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mester.jpg
// module id = 25
// module chunks = 0